/**
 * imageGainCurve — 22/07/2026 (retour user prod).
 * « La réputation et la notoriété s'acquièrent trop vite : 100 % en
 * juillet/août année 1. Investir dans les fonctions support n'apporte
 * alors plus rien. »
 *
 * Deux mécanismes :
 *   1. Rendements décroissants : les GAINS (jamais les pertes) sont
 *      atténués au fur et à mesure que l'indicateur monte. Atteindre
 *      90+ demande un vrai travail d'image (fonctions support).
 *   2. Érosion mensuelle : l'image s'entretient. Plus on est connu,
 *      plus le marché attend de la constance — l'érosion croît avec
 *      le niveau. Les passifs mensuels des fonctions support servent
 *      désormais à MAINTENIR un haut niveau, pas seulement à monter.
 */

// Atténuation des gains positifs selon le niveau courant (0-100).
export function scaleImageGain(current, delta) {
  if (!delta || delta <= 0) return delta || 0;
  const c = current || 0;
  const factor = c >= 90 ? 0.15
    : c >= 80 ? 0.3
    : c >= 70 ? 0.5
    : c >= 60 ? 0.75
    : 1;
  return delta * factor;
}

// Érosion mensuelle de la réputation (appliquée au 1er du mois).
export function monthlyReputationErosion(current) {
  return Math.max(0.5, (current || 0) * 0.015);
}

// Érosion mensuelle de la notoriété (le marché oublie vite).
export function monthlyNotorietyErosion(current) {
  return Math.max(0.5, (current || 0) * 0.02);
}
